const allowedNodes = [
	// "a",
	"abbr",
	"acronym",
	"address",
	"applet",
	"area",
	"article",
	"aside",
	"audio",
	"b",
	"base",
	"basefont",
	"bdi",
	"bdo",
	"bgsound",
	"big",
	"blink",
	// "blockquote",
	// "body",
	// "br",
	"button",
	"canvas",
	"caption",
	"center",
	"cite",
	"code",
	"col",
	"colgroup",
	"content",
	"data",
	"datalist",
	"dd",
	"decorator",
	"del",
	"details",
	"dfn",
	"dir",
	"div",
	"dl",
	"dt",
	"element",
	// "em",
	"embed",
	"fieldset",
	"figcaption",
	"figure",
	"font",
	"footer",
	"form",
	"frame",
	"frameset",
	// "h1",
	// "h2",
	// "h3",
	// "h4",
	// "h5",
	// "h6",
	"head",
	"header",
	"hgroup",
	"hr",
	// "html",
	// "i",
	"iframe",
	"img",
	"input",
	// "ins",
	"isindex",
	"kbd",
	"keygen",
	"label",
	"legend",
	// "li",
	"link",
	"listing",
	"main",
	"map",
	"mark",
	"marquee",
	"menu",
	"menuitem",
	"meta",
	"meter",
	"nav",
	"nobr",
	"noframes",
	"noscript",
	"object",
	// "ol",
	"optgroup",
	"option",
	"output",
	// "p",
	"param",
	"plaintext",
	"pre",
	"progress",
	"q",
	"rp",
	"rt",
	"ruby",
	"s",
	"samp",
	"script",
	"section",
	"select",
	"shadow",
	"small",
	"source",
	"spacer",
	"span",
	"strike",
	// "strong",
	"style",
	"sub",
	"summary",
	"sup",
	"table",
	"tbody",
	"td",
	"template",
	"textarea",
	"tfoot",
	"th",
	"thead",
	"time",
	"title",
	"tr",
	"track",
	"tt",
	"u",
	// "ul",
	"var",
	"video",
	"wbr",
	"xmp"
];

const styleObjToCSS = styleObj =>
	Object.keys(styleObj).reduce((acum, style) => {
		return (style && styleObj[style]
			? `${style}:${styleObj[style]}; ${acum}`
			: ""
		).trim();
	}, "");

const nodeAttributesToObj = attrs => {
	const objAttrs = {};
	for (let i = attrs.length - 1; i >= 0; i--) {
		if (attrs[i].name !== "style") {
			if (attrs[i].name && attrs[i].value) {
				objAttrs[attrs[i].name] = attrs[i].value;
			}
		} else {
			const stylesInText = attrs[i].value.split(";");
			const styles = stylesInText.reduce((acum, style) => {
				const components = style.split(":");
				if (components[0] && components[1]) {
					acum[components[0]] = `${components[1]}`;
				}
				return acum;
			}, {});
			if (Object.keys(styles).length > 0) {
				objAttrs["style"] = styles;
			}
		}
	}
	return objAttrs;
};

export function entityMapper(entity) {
	let type = entity.type;
	let data = { ...entity.data };

	if (type === "IMAGE") {
		// added to support the existing image option in the editor
		type = "IMG";
		data = { attributes: data, innerHTML: "" };
	}

	data.attributes = data.attributes ? data.attributes : {};
	let styleAsAttribute;
	if (data.attributes.style) {
		styleAsAttribute = styleObjToCSS(data.attributes.style);
	}

	const attributes = Object.keys(data.attributes).reduce(
		(acum, key) =>
			(key === "style"
				? `${key}="${styleAsAttribute}" ${acum}`
				: `${key}="${data.attributes[key]}" ${acum}`
			).trim(),
		""
	);

	const node = type.toLowerCase();
	if (allowedNodes.includes(node)) {
		if (node === "link" && data.title) {
			return `<a href="${data.url}" target="${
				data.target}" ${attributes}>${data.title}</a>`;
		} else {
			return `<${node} ${attributes}>${data.innerHTML}</${node}>`;
		}
	}
	return "";
}

export function entityMapperToComponent(entity) {
	const TagName = entity.type.toLowerCase();
	let attr = { ...entity.data.attributes, contenteditable: "true" };
	if (entity.type === "LINK" && entity.data.innerHTML) {
		return () => (
			<a
				{...attr}
				dangerouslySetInnerHTML={{
					__html: entity.data.innerHTML
				}}
			/>
		);
	}
	if (entity.type === "IMAGE") {
		return () => <img {...attr} />;
	}
	if (entity && entity.type && !entity.data.innerHTML) {
		return () => <TagName {...attr} />;
	} else if (entity && entity.type && entity.data.innerHTML) {
		return () => (
			<TagName
				{...attr}
				dangerouslySetInnerHTML={{
					__html: entity.data.innerHTML
				}}
			/>
		);
	}

	return "";
}

export function customChunkRenderer(nodeName, node) {
	if (allowedNodes.includes(nodeName)) {
		let objAttrs = {};

		if (node.hasAttributes()) {
			objAttrs = nodeAttributesToObj(node.attributes);
		}

		console.log(objAttrs);

		return {
			type: nodeName.toString().toUpperCase(),
			mutability: "MUTABLE",
			data: {
				// Pass whatever you want here (like id, or classList, etc.)
				innerText: node.innerText,
				innerHTML: node.innerHTML,
				attributes: objAttrs
			}
		};
	}
	return null;
}

export function customBlockRenderFunc(block, config) {
	if (block.getType() === "atomic") {
		const contentState = config.getEditorState().getCurrentContent();
		console.log(block.getEntityAt(0));
		console.log(contentState.getEntity(block.getEntityAt(0)));
		const entity = contentState.getEntity(block.getEntityAt(0));
		return {
			component: entityMapperToComponent(entity),
			editable: false,
			props: {
				children: () => entity.innerHTML
			}
		};
	}
	return undefined;
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/richText/helper.tsx